import { FONT_WEIGHTS } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/constants'
import { FontWeightType } from 'components/VisualStudioPlayground/VisualEditor/Types'

export const getFontWeightAsNumber = (weight: string) =>
  parseInt(Object.entries(FONT_WEIGHTS).find(([_, value]) => value === weight)?.[0] ?? '400') as FontWeightType
